import { Component, OnInit, Input, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import { DatosFechas } from '../../../../models/datos-Fechas';
import { DatosFechasDetalleComponent } from '../datos-fechas-detalle/datos-fechas-detalle.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DatosFechasService } from '../../../../services/datos-fechas.service';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-datos-fechas-cab',
  templateUrl: './datos-fechas-cab.component.html',
  styleUrls: ['./datos-fechas-cab.component.css']
})
export class DatosFechasCabComponent implements OnInit, OnChanges {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  datoFecha: DatosFechas;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  datosFechasHistoryList: any;
  datosFechasList: DatosFechas[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  datosFechas: DatosFechas[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  datosFechasInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildDatoFechaDetalle') datoFechaDetalle: DatosFechasDetalleComponent;

  constructor(private dialog: MatDialog, 
              private erroresService: ErroresService, 
              private snackBar: MatSnackBar, 
              private fechasSrv: DatosFechasService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerDatosFechas(false);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Datos Fechas")) this.permisoEdicion = true;
  }

  obtenerDatosFechas(agrupar)
  {
    this.buscando = true;
    this.fechasSrv.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.fechaEvento = this.momentService.convertDateServer(currentValue.fechaEvento);
        });

        this.datosFechas = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(datoFecha)
  {
    if (datoFecha.id != 0)
    {
      this.obtenerHistorial(datoFecha);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.datoFecha = datoFecha;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.datoFecha))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.fechasSrv.eliminar(this.datoFecha.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let datoFecha = this.datosFechasList.filter(d => d.id != this.datoFecha.id)[0];
              if (datoFecha == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(datoFecha);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.datoFecha))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.datoFechaDetalle.form.controls['desde'].disable();
        $this.datoFechaDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let datoFecha = this.datosFechasList.find(d => d.id == index);
    this.datoFecha = datoFecha;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.datoFechaDetalle.setearForm(this.datoFecha);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.datoFechaDetalle.form.getRawValue();

      let datosFec: DatosFechas = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        claseFecha: formulario.claseFecha,
        fechaEvento: this.momentService.saveDateServer(formulario.fechaEvento, false)
      };

      this.fechasSrv.guardar(datosFec, this.cortarRegistro).subscribe(
        datoFecha =>
        {
          datoFecha.desde = this.momentService.convertDateServer(datoFecha.desde);
          datoFecha.hasta = this.momentService.convertDateServer(datoFecha.hasta);
          datoFecha.fechaEvento = this.momentService.convertDateServer(datoFecha.fechaEvento);
          

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Dato Fecha guardado", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(datoFecha);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          this.datoFechaDetalle.setearForm(datoFecha);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.datoFechaDetalle.form.controls['id'].setValue(0);
      this.datoFechaDetalle.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.datoFechaDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.datosFechasHistoryList = [];
    this.datosFechasList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerDatosFechas(false);
  }

  private obtenerHistorial(dato: DatosFechas)
  {
    this.fechasSrv.getHistoryByClase(dato.personal, dato.claseFecha).subscribe(
      datoFecha =>
      {
        datoFecha.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.fechaEvento = this.momentService.convertDateServer(currentValue.fechaEvento);
        });

        this.datosFechasHistoryList = [];
        datoFecha.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.datosFechasHistoryList.push(item);
        });

        this.datosFechasList = datoFecha;
        this.verDetalle = true;
        this.datoFecha = dato;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.datoFechaDetalle.form.get("desde").value.toDateString();
    let hasta = this.datoFechaDetalle.form.get("hasta").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.datoFechaDetalle.form.get("desde").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.datoFechaDetalle.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.datoFechaDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.datoFechaDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
  
}
